const themes = {
	default: {
		palette: {
			type: 'light',
		},
		typography: { useNextVariants: true },

		
	},
	hyperDart: {
		palette: {
			primary: {
				main: '#F05F40',
				textColor:'#777777'
			},
			secondary: {
				main: '#40f0bb'
			},
			type: 'light',
		},
		typography: { useNextVariants: true }
	},
	hyperDartLightsOut: {
		palette: {
			primary: {
				main: '#F05F40',
				textColor:'#fff'
      },
			type: 'dark',
			background: {
				default: '#000',
				paper: '#000'
			}
		},
		shadows: Array(25).fill('0px 4px 12px #888888'),
		typography: { useNextVariants: true },
  },

}

export default themes;
